export default {
  Home: 'Home',
  Work: 'Work',
  Other: 'Other',
  Shipping: 'Shipping',
  'Home Address': 'Home Address',
  'Marketing Address': 'Marketing Address',
  'Service Address': 'Service Address',
  'Shipping Address': 'Shipping Address',
  'Work Address': 'Work Address'
};
